/*
 *
 * Spaces actions
 *
 */

import { createAction } from '@reduxjs/toolkit';

import { SLICE_NAME } from './constants';
import { Space } from './spaces';

export const fetchSpaces = createAction<boolean>(`${SLICE_NAME}/fetchSpaces`);

export const updateSpace = createAction<Partial<Space>>(
  `${SLICE_NAME}/updateSpace`,
);

export const deleteSpace = createAction<string>(
  `${SLICE_NAME}/deleteSpace`,
);
